module.exports = __webpack_public_path__ + "static/media/externalBarn_14.c3d7ed24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_14.png
// module id = 1302
// module chunks = 3